import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal, PageHero } from "@/components/Shared";
import { LeadForm } from "@/components/LeadForm";
import { CONTACT } from "@/data/site";
import { useSeo } from "@/components/Seo";

const INFO = [
  { icon: Phone, label: "Phone", value: CONTACT.phone },
  { icon: Mail, label: "Email", value: CONTACT.email },
  { icon: MapPin, label: "Address", value: CONTACT.address },
  { icon: Clock, label: "Hours", value: "Mon–Fri, 8am – 6pm PST" },
];

export default function Contact() {
  useSeo({
    path: "/contact",
    title: "Become a Distribution Partner",
    description:
      "Partner with Hays Holdings, a trusted U.S. distribution company. Contact us to expand your brand into new retail markets through nationwide wholesale and retail distribution.",
    keywords:
      "contact distribution company, become a distribution partner, national distributor contact, wholesale distribution partner, brand distribution partner, U.S. product distributor",
    extraJsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "@id": "https://www.haysholdingsinc.com/contact#webpage",
        url: "https://www.haysholdingsinc.com/contact",
        name: "Become a Distribution Partner | Hays Holdings Inc",
        description:
          "Contact Hays Holdings to partner with a national product distribution company and expand your brand into U.S. retail markets.",
        about: { "@id": "https://www.haysholdingsinc.com/#organization" },
        inLanguage: "en-US",
      },
    ],
  });
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Let's Grow Together"
        title="Request a partnership review"
        subtitle="Tell us about your brand and goals. Our partnerships team reviews every submission and responds within one business day."
      />

      <section className="bg-white py-20 md:py-28">
        <div className="container-pn grid grid-cols-1 gap-14 lg:grid-cols-2">
          <Reveal>
            <p className="label-eyebrow text-orange">Talk To Us</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-navy sm:text-4xl">
              Connect with our partnerships team
            </h2>
            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
              {INFO.map((c) => (
                <div key={c.label} className="border border-border bg-white p-6">
                  <c.icon size={22} className="text-orange" />
                  <p className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-foreground/50">{c.label}</p>
                  <p className="mt-1 break-words font-heading text-base font-semibold text-navy">{c.value}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 border border-border bg-navy p-7 text-white">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-light">For Manufacturers</p>
              <p className="mt-2 text-sm leading-relaxed text-white/80">
                Whether you're looking to expand distribution, grow Amazon sales, or enter new
                channels — we'll review your brand and map the growth opportunity together.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="border border-border bg-white p-8 md:p-10">
              <LeadForm />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
